import { AppState } from '../../reducers';

export function selectProductLayout(state: AppState) {
  const {
    userSelectedLayout,
    collectionDefaultLayout,
  } = state.areas.productCollection;

  return userSelectedLayout || collectionDefaultLayout;
}
